import { useProject } from './useProject';

export function useActiveScene() {
  const project = useProject();
  return project?.scenes.find(scene => scene.active) ?? project?.scenes[0];
}
